export const initialValues: { [key: string]: { [key: string]: any } } = {
  familyMemberName: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 3,
      maxLength: 150,
    },
  },
  age: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 1,
      maxLength: 2,
    },
  },
  relation: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  wages: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: false,
    },
  },
  pensions: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: false,
    },
  },
  publicAssistance: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: false,
    },
  },
  otherIncome: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: false,
    },
  },
};
export const relation = ['Spouse/Partner', 'Child', 'Parent', 'Sibling', 'Cousin', 'Aunt/Uncle', 'Grandparent', 'Self', 'Not related'];
